



import React, { useEffect, useMemo, useState, Suspense, lazy } from 'react';
//import { DeleteBannerImage, DeleteHeaderTypes, GetAllBanner, GetAllHeaderTypes, GetAllLogos, GetAllTenants, deletLogoImages, getAllArea } from '../../../../services/CommonService';
import { Badge, Button, Card, Col, Dropdown, Modal, Table } from "react-bootstrap"
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import Pagination from "react-js-pagination";

import { ChangeUserProgram, GetAllTenants, GetAllUsers, GetAllUsersData, GetPrograms, commonGet } from '../../../services/CommonService';
import EventBus from '../../../services/EventBus';



const ChangeProgram = ({userprops}) => {
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const [postModal, setPostModal] = useState(false);
    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
        </svg>
    );
    const [data, setData] = useState([]);
    const [tenantid, setTenantId] = useState(null);
    const [tenantlist, setTenantList] = useState([]);
    const [tenantdata, setTenantData] = useState({});
    const [updateitem, setUpdateItem] = useState({});
    const [activePage, setActivePage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [username, setUserName] = useState(null);
    const [programid,setProgramid] =useState(null);
    const [email, setEmail] = useState(null);
    const [mobilenumber, setMobilenumber] = useState(null);
    useEffect(() => {
        //getBanner();
        getTenants();
        getDatalist();
        EventBus.on("loadpagedata", (data) => {
            let obj = {
                payload: {
                    "pageNo": data?.message?.page,
                    "size": 10
                }
            }
            loadData(data?.message?.page);
            //dispatch(fetchAllPaitentsForMedicalBoard({obj:obj}));
        });
        EventBus.remove("loadpagedata");
    }, []);

    const handlePageChange = async (pn) => {
        if (pn !== activePage && !isNaN(pn)) {
            loadNextsetofRecords(pn);
        }
    };
    const loadNextsetofRecords = async (pn) => {
        setActivePage(pn);
        EventBus.dispatch("loadpagedata", {
            message: {
                "page": pn
            }

        });
    };

    const loadData = async (pn) => {

        const reqparams = {
            pageno: pn,
            query: { userid: userprops.id },
            ptype:'PROGRAMPURCHASES'
        }

        if (username != null) {
            reqparams.query.programid =username;
        }
       
        const respData = await commonGet(reqparams);
        setData(respData?.data);
        setTotalRecords(respData?.data?.total);
    }

    const getDatalist = async () => {
        let reqparams = null;

        
            reqparams = {
                pageno: '1',
                query: { userid: userprops.id },
                ptype:'PROGRAMPURCHASES'

            }
        
        const respData = await commonGet(reqparams);
        setData(respData?.data?.docs);
        setTotalRecords(respData?.data?.total);

    }

    const getTenants = async () => {
        const reqdata = {
            pageno: '-1',
            query: { status: 'Active' }
        }
        const Response = await GetPrograms(reqdata)
        setTenantList(Response.data);
    }

    const openModal = async () => {

        if (tenantid == null) {
            notifyTopFullWidth("Please choose the tenant");
        } else {
            setUpdateItem({});
            setPostModal(true);
        }
    }

    const [changeid,setChangeid] =useState(null);
    const changepurchaseprogram = async(item) =>{
        setChangeid(item.id);
        setPostModal(true);
    }


    const handleNameChange = async (e) => {
        const { name, value } = e.target;
      
        
        
        if(value ==''){
        await setUserName(null);   
        getDatalist();
        }else{
        await setUserName(value);    
        getDatalistbyname(value);
        }
    

    }

    const getDatalistbyname = async (name) => {
        let reqparams = null;
        console.log(username);

      
            reqparams = {
                pageno: '1',
                query: { userid: userprops.id,programid:username },
                ptype:'PROGRAMPURCHASES'

            }
            

           
        
        const respData = await commonGet(reqparams);
        setData(respData.data.docs);
        setTotalRecords(respData.data.totalDocs);

    }

    const adminChangeprogram =async() =>{

        if(programid ==null){
            notifyTopFullWidth("Please choose program id to change");
        }else{
            const reqdata ={
                programid :programid,
                userid:userprops.id,
                purchaseprogramid:changeid,
                email:userprops.email

            }
            const resData = await ChangeUserProgram(reqdata);
            if(resData.id){
                notifyTopFullWidth("user program changed successfully");
                setPostModal(false);
                getDatalist();
            }else{
                notifyTopFullWidth("Failed to change user program");
            }
        }

       

    }

   const handleChange =(e) =>{
    const { name, value } = e.target;
    
    setProgramid(value);
      
        

   }

   const closemodal =async() =>{
    setPostModal(false);
   }





    return (<>
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />

        <Col lg={12}>
            <Card>
                <Card.Header>

                    <Card.Title>User Programs


                    </Card.Title>
                    <div className="col-lg-6">
                        <select className="form-control" name="username"
                            value={username} onChange={handleNameChange}>
                            <option value=''>Select Program</option>
                            {tenantlist.map(item => (
                                <option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                   
                  

                  

                </Card.Header>
                <Card.Body>
                    <Table responsive>
                        <thead>
                            <tr>

                                <th>
                                    <strong>Program Name</strong>
                                </th>
                                



                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map(item => (
                                <tr>
                                    <td>
                                        <strong>{item.name}</strong>
                                    </td>

                                    
                                    <td>
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="success"
                                                className="light sharp i-false"
                                            >
                                                {svg1}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => changepurchaseprogram(item)}>
                                                 
                                                        Change
                                               
                                                </Dropdown.Item >

                                                

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <div >

                        <Pagination
                            activePage={activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            activeClass="active"
                            itemClass="page-item"
                            innerClass="pagination mb-0"
                            linkClass="page-link"
                            firstPageText="First"
                            lastPageText="Last"
                            prevPageText="Previous"
                            nextPageText="Next"
                            disabledClass="disabled"
                            activeLinkClass="disabled"
                        />
                    </div>
                </Card.Body>
            </Card>
        </Col>

        <Modal className="modal fade" size="lg" show={postModal} onHide={setPostModal} >
            <div className="" role="document">
                <div className="">
                    <form >
                        <div className="modal-header">

                            <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">

                       <select className="form-control" name="programid"
                            value={programid} onChange={handleChange}>
                            <option value=''>Select Program</option>
                            {tenantlist.map(item => (
                                <option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    
                        </div>
                        <div className="modal-footer">
                              <button type="button" onClick ={adminChangeprogram} className="btn btn-primary" >Save</button>      
</div>
                    </form>

                </div>
            </div>
        </Modal>

    </>)
}
export default ChangeProgram;